import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MaterialModule } from 'src/app/app-material.module';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortModule, Sort, SortDirection } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { CommonsService } from 'src/app/services/commons/commons.service';
import { DettaglioCorsiComponent } from './dettaglio-corsi/dettaglio-corsi.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-corsi',
  templateUrl: './corsi.component.html',
  styleUrls: ['./corsi.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule]
})
export class CorsiComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<CorsiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api: CommonsService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar) {
  }

  dataSource = new MatTableDataSource<any>;
  errorVar: String;
  errorMsg = "Non risultano informazioni di dettaglio dei corsi legati a ";
  gridColumns = ['Descrizione', 'Azioni'];
  idPercorso = this.data.idPercorso;
  tipoPercorso = this.data.tipoPercorso;
  pageIndex = 0;
  pageSize = 5;
  paginatorSize: any;
  result: any;
  originalResult: any;
  savedEvent: any;


  ngOnInit(): void {
    switch (this.tipoPercorso) {
      case 1:
          this.errorVar = "questa figura regolamentata abilitante";
          break;

      case 2:
          this.errorVar = "questo percorso regolamentato";
          break;

      default:
          break;
    }
    this.errorMsg += this.errorVar;
    this.ricercaCorsi(this.idPercorso, this.tipoPercorso)
  }

  ricercaCorsi(idPercorso: number, tipoPercorso: number) {
    this.api.ricercaCorsi(idPercorso, tipoPercorso).subscribe({
      next: (response: any) => {
        this.paginatorSize = response.result.length;
        this.originalResult = response.result;
        this.result = response.result.slice(0, this.pageSize);
        if(this.paginatorSize <= 0) {
          this.snackBar.open(this.errorMsg, 'close', { panelClass: 'errorSnack' })
        }

      }
    })
  }

  dettaglioCorso(el : any) {
    const dialogRef = this.dialog.open(DettaglioCorsiComponent, {
      data: { title: "STANDARD FORMATIVO", corso: el },
      height: 'auto',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    })
  }

  onPaginateChange(event: any) {
    this.result = [ ...this.originalResult ];
    let start = event.pageSize*event.pageIndex;
    let end = start + event.pageSize;
    this.result = this.result.slice(start, end);
  }

  printCol(col: any) {
    let col_name;
    switch (col) {
      case "Descrizione": {
        col_name = "Descrizione"
        break;
      }
      case "Azioni": {
        col_name = "Azioni"
        break;
      }
      default: {
        col_name = ""
        break;
      }
    }

    return col_name;
  }

  printElement(col: any, el: any) {
    let element;
    switch (col) {
      case "Azioni": {
        element = '';
        break;
      }
      case "Descrizione": {
        element = el.descrizione
        break;
      }
    }

    return element;
  }

}
